import { useId } from "react";
import { Stack, Tab } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";
import { UnderlyingListDaysCount } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";
import { UNDERLYING_LIST_PERIOD_FILTER_TEST_ID } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.test-ids";
import { TabsList } from "src/components-mui/tabs/tabs-list";

const DAYS_COUNT_OPTIONS: ReadonlyArray<UnderlyingListDaysCount> = [UnderlyingListDaysCount.Seven, UnderlyingListDaysCount.Thirty];

interface IListsPeriodFilterProps {
    daysCount: UnderlyingListDaysCount;
    onChange: (daysCount: UnderlyingListDaysCount) => void;
}

export const ListsPeriodFilter = ({ daysCount, onChange }: IListsPeriodFilterProps) => {
    const { t } = useTranslation("underlying-overview");
    const labelId = useId();

    const handleChange = (value: string | number) => onChange(value as UnderlyingListDaysCount);

    return (
        <Stack direction="row" sx={{ alignItems: "center", gap: 2 }} data-test-id={UNDERLYING_LIST_PERIOD_FILTER_TEST_ID}>
            <Typography id={labelId} component="span" sx={{ display: { xs: "none", sm: "block" }, fontSize: "md", fontWeight: "bold" }}>
                {t("filter.label")}
            </Typography>
            <TabsList customVariant="full" fitContent value={daysCount} onChange={handleChange} aria-labelledby={labelId}>
                {DAYS_COUNT_OPTIONS.map(option => (
                    <Tab key={option} value={option} label={t("filter.option", { 0: option })} disableRipple />
                ))}
            </TabsList>
        </Stack>
    );
};
